













import { Vue, Component, Watch } from 'vue-property-decorator';
import Bus from '@/common/util/bus';

@Component({
    components: {},
})
export default class NavBar extends Vue {
    public sysName: string = '';
    public collapsed: boolean = false;
    public sysUserName: string = '';
    public anchorId: string = '';
    public showButton: boolean = false;

    created() {}
    @Watch('$route')
    routeChange() {}
    //折叠导航栏
    public collapse = function () {
        this.collapsed = !this.collapsed;
        Bus.$emit('collapsed', this.collapsed);
    };
}
